import { createSlice } from "@reduxjs/toolkit";
import {
  fetchIndirectIncomeBalance,
  fetchIndirectIncomeAccountsBySearch,
} from "./indirectIncomeBalanceThunk";

const initialState = {
  list: [],
  loading: false,
  incomeAccounts: [],
  incomeAccountLoading: false,
  filters: {
    filterType: "All Income Account", // "All Income Account" | "Account Wise"
    accId: null,
  },
};

const indirectIncomeBalanceSlice = createSlice({
  name: "indirectIncomeBalance",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIndirectIncomeBalance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIndirectIncomeBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.incomes || [];
      })
      .addCase(fetchIndirectIncomeBalance.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchIndirectIncomeAccountsBySearch.pending, (state) => {
        state.incomeAccountLoading = true;
      })
      .addCase(fetchIndirectIncomeAccountsBySearch.fulfilled, (state, action) => {
        state.incomeAccountLoading = false;
        state.incomeAccounts = action.payload;
      })
      .addCase(fetchIndirectIncomeAccountsBySearch.rejected, (state) => {
        state.incomeAccountLoading = false;
        state.incomeAccounts = [];
      });
  },
});

export const { setFilters } = indirectIncomeBalanceSlice.actions;
export default indirectIncomeBalanceSlice.reducer;
